export function GetOnlineOrderStatuses() {
  return [
    {
      key: 0,
      description: "Pending"
    },
    {
      key: 1,
      description: "Waiting For Payment"
    },
    {
      key: 2,
      description: "Paid"
    },
    {
      key: 3,
      description: "Cancelled"
    }
  ];
}

export function GetOnlineOrderStatusDescription(value) {
  let orderStatus = GetOnlineOrderStatuses().find(item => item.key === value);
  return orderStatus.description;
}
